import { render, staticRenderFns } from "./FoodCategories.vue?vue&type=template&id=f25e0d94&scoped=true&"
import script from "./FoodCategories.vue?vue&type=script&lang=js&"
export * from "./FoodCategories.vue?vue&type=script&lang=js&"
import style0 from "./FoodCategories.vue?vue&type=style&index=0&id=f25e0d94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25e0d94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VBtnToggle,VSlideGroup,VSlideItem,VTextField})
